import { IProfileState } from "@/core/interfaces/profile.interface";

const profileState: IProfileState = {
  isFetchingProfile: false,
  isUpdatingProfile: false,
  isVerifyingAuthenticator: false,
  authProfile: null,
  twoFactorSetup: null,
};

export default profileState;
